import DeleteIcon from '@mui/icons-material/Delete'
import { Box, IconButton, Link, Paper, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import { messages } from '../../messages'

type SharedWaypointSectionProps = {
  waypointNumber?: number
  label?: string
  locationName: string
  address?: string
  onAddWaypointBefore?: () => void
  onAddWaypointAfter?: () => void
  onDelete?: () => void
  isUserCreated?: boolean
}

const SharedWaypointSection = ({
  waypointNumber,
  label,
  locationName,
  address,
  onAddWaypointBefore,
  onAddWaypointAfter,
  onDelete,
  isUserCreated = false,
}: SharedWaypointSectionProps) => {
  const { formatMessage } = useIntl()

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        my: 2,
        borderStyle: 'dashed',
        borderColor: 'grey.400',
        bgcolor: 'grey.50',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                      {label || formatMessage(messages.waypointNumber, { number: waypointNumber })}
          </Typography>
          <Box sx={{ ml: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
              {locationName}
            </Typography>
            {address && (
              <Typography variant="body2" color="text.secondary">
                {address}
              </Typography>
            )}
          </Box>
          {isUserCreated && onDelete && (
            <IconButton
              size="small"
              onClick={onDelete}
              sx={{ ml: 1 }}
              aria-label="delete waypoint"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
          {onAddWaypointBefore && (
            <Link
              component="button"
              variant="body2"
              onClick={onAddWaypointBefore}
              sx={{ cursor: 'pointer', color: 'primary.main' }}
            >
              {formatMessage(messages.addWaypointBefore)}
            </Link>
          )}
          {onAddWaypointAfter && (
            <Link
              component="button"
              variant="body2"
              onClick={onAddWaypointAfter}
              sx={{ cursor: 'pointer', color: 'primary.main' }}
            >
              {formatMessage(messages.addWaypointAfter)}
            </Link>
          )}
        </Box>
      </Box>
    </Paper>
  )
}

export default SharedWaypointSection
